import './index.css'
import React from 'react';
import Autocomplete from '../common/Autocomplete';


export default function BasicForm(props: any) {
  const action = props.action
  const handleSelection = props.handleSelection
  const ticketForm = props.ticketForm
  const titlesList = props.titlesList
  const statusList = props.statusList
  const prioritiesList = props.prioritiesList
  
  return (
    <React.Fragment>
      <div className='tkt-form-section'>
        <div className='tkt-form-section-title'>
          <p>Datos Básicos</p>
        </div>

        <div className='tkt-form-section-item'>
          <Autocomplete
            label='Título'
            placeholder='Título'
            disabled={!(action === 'create' || action === 'edit')}
            options={titlesList}
            value={ticketForm.title}
            name='title'
            handleSelection={handleSelection}
            required
          />
        </div>

        <div className='tkt-form-section-item'>
          <Autocomplete
            label='Prioridad'
            placeholder='Prioridad'
            disabled={!(action === 'create')}
            options={prioritiesList}
            value={ticketForm.priority}
            name='priority'
            handleSelection={handleSelection}
            required
          />
        </div>

        <div className='tkt-form-section-item'>
          <Autocomplete
            label='Estado'
            placeholder='Estado'
            disabled={!(action === 'create')}
            options={statusList}
            value={action === 'create' ? ticketForm.status_n : ticketForm.status_0}
            name='status_n'
            handleSelection={handleSelection}
            required
          />
        </div>

      </div>

    </React.Fragment>
  );
}
